export const gtmNoScript =
  '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KFNQ5FG" height="0" width="0" style="display:none;visibility:hidden"></iframe>'
